module.exports = __webpack_public_path__ + "img/Angelina.3570bf99.jpeg";